<template>
  <div class="mallManagement">
    <div class="main">
      <div class="lft">
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :unique-opened="true"
          text-color="#000"
          background-color="#fff"
          active-text-color="#2F54EB"
          router
        >
          <template v-for="item in newData">
            <el-submenu
              v-if="item.children && item.children.length"
              :index="item.path"
              :key="item.path"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>

              <!-- 二级菜单 -->
              <template v-for="itemChild in item.children">
                <el-submenu
                  v-if="itemChild.children && itemChild.children.length"
                  :index="itemChild.path"
                  :key="itemChild.path"
                >
                  <template slot="title">
                    <i :class="itemChild.icon"></i>
                    <span>{{ itemChild.name }}</span>
                  </template>
                  <!-- 三级菜单 -->
                  <el-menu-item
                    v-for="itemChild_Child in itemChild.children"
                    :index="itemChild_Child.path"
                    :key="itemChild_Child.path"
                  >
                    <i :class="itemChild_Child.icon"></i>
                    <span slot="title">
                      {{ itemChild_Child.name }}
                    </span>
                  </el-menu-item>
                </el-submenu>

                <el-menu-item
                  v-else
                  :index="itemChild.path"
                  :key="itemChild.path"
                >
                  <i :class="itemChild.icon"></i>
                  <span slot="title">{{ itemChild.name }}</span>
                </el-menu-item>
              </template>
            </el-submenu>

            <el-menu-item v-else :index="item.path" :key="item.path">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="rgt">
        <transition name="el-fade-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { initSideBar } from "./initConfig";
export default {
  // 説明：：这个为单独的内嵌页的左侧导航
  // 説明：：这个为单独的内嵌页的左侧导航
  // 説明：：这个为单独的内嵌页的左侧导航
  name: "merchants",
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  watch: {
    classid: function(val) {
      console.log("我变换classID", val);
    }
  },
  data() {
    return {
      isCollapse: false,
      classid: this.$route.params.id, //分类
      classiline: this.$route.params.inline, //内页iline
      newData: [],
      initSideBar: initSideBar, // 导航数据
      inlineGift: [
        {
          path: "/apply/newVip/13/market/marketing/gift/inlineGift/list",
          name: "赠品列表"
        },
        {
          path: "/apply/newVip/13/market/marketing/gift/inlineGift/ruleList",
          name: "赠品规则"
        }
      ],
      signData: [
        {
          path: "/apply/newVip/13/market/marketing/client/sign/signData/set",
          name: "签到规则设置"
        },
        {
          path:
            "/apply/newVip/13/market/marketing/client/sign/signData/signList",
          name: "签到记录"
        }
      ]
    };
  },
  beforeMount() {
    switch (this.classiline) {
      case "inlineGift":
        this.newData = this.inlineGift;
        break;
      case "signData":
        this.newData = this.signData;
        break;
    }
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"])
  }
};
</script>
<style scoped>
.el-menu >>> .is-active {
  background-color: rgba(47, 84, 235, 0.1) !important;
}
</style>

<style lang="scss" scoped>
.mallManagement {
  height: 100%;
  position: relative;
  overflow-y: hidden;

  i {
    color: #000;
  }
  .main {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    .lft {
      height: 100%;
      background: #ffffff;
      overflow: hidden;
      color: #000;
      border-right: 1px solid #dcdfe6;
      border-left: 1px solid #dcdfe6;
      .el-menu {
        border: 0;
      }
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 160px;
        min-height: 400px;
      }
    }
    .rgt {
      flex: 1;
    }
  }
}
</style>

<style lang="scss">
.mallManagement {
  .el-menu-item-group__name {
    padding: 0;
  }
}
</style>
